import React from 'react';
import Image from 'next/image';
import { Typography } from '@/components/common';

interface Props {
	title: React.ReactNode;
	description: string;
	image: string;
}

export const HowWorksCard: React.FC<Props> = ({
	title,
	description,
	image,
}) => {
	return (
		<div className="rounded-[32px] bg-white border border-[#0D061614] shadow-shadow2 flex flex-col">
			<div className="relative w-full h-[200px] lg:h-[289px]">
				<Image
					src={image}
					alt="device"
					fill
					className="object-cover rounded-t-[32px]"
					unoptimized
				/>
			</div>
			<div className="space-y-4 py-8 px-6 lg:py-10 lg:px-8 h-[180px] lg:h-[193px]">
				{title}
				<Typography type="regular-16" className="!text-sm lg:!text-base">
					{description}
				</Typography>
			</div>
		</div>
	);
};
